module.exports = __webpack_public_path__ + "img/NF.32f8d997.svg";